import React, {PureComponent, Component} from 'react';
import Table from '../../../components/table/Table';
import {Col, Button, Card, CardBody,Badge} from 'reactstrap';
//import EditProviderForm from './EditProviderForm';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    routes_open_form,
} from '../../../redux/actions/AdminActions';
import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from '../../../modules/environment';
import EditCellularRouteForm from './EditCellularRouteForm'



const names = ["", "רגיל", "כשר", "דור 5", "בזק", "הוט", "סלקום", "פרטנר", "יס"];

class CellularRouteTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false,
            tmp: 0
        };
    }

    editRoute = (id) => {
        if (id === this.state.selectedID && this.state.windowType === 2) {
            this.setState({selectedID: 0, windowType: 0});
        }
        else {
            this.props.dispatch(routes_open_form(id));
            this.setState({
                selectedID: id, windowType: 2, error: false,
            });
        }
    };

    getRow = (index) => {

        let logoUrl = environment.getServerBasePath() + '/cellular_route/download?id=' + index + '&hash=' + new Date().getTime();

        return (

            <React.Fragment key={index}>

                <tr key={index}>
                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                            onClick={() => this.editRoute(index)}>ערוך</Button>
                    </td>

                    <td>
                        <img src={logoUrl} style={{maxWidth: '200px', objectFit: 'cover' }} />
                    </td>
                    <td>{names[index]}</td>
                    <td>{index}</td>


                </tr>

                {this.state.windowType === 2 && index === this.state.selectedID &&
                <tr key={index + 2000}>
                    <td colSpan="7">
                        <EditCellularRouteForm index={index} onClose={() => this.editRoute(index)} refreshPage={() => this.refreshPage()}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    };

    refreshPage = () => {
        //window.location.reload(false);
        this.setState({});
    };

    render() {
        /*const rows = this.props.data.map((provider, index) =>
            this.getRow(provider, index)
        );*/

        let rows = [];

        for(let i = 1; i < 9; i++) {
            rows.push(this.getRow(i), false);
        }

        //const isAdding = this.props.provider && this.props.provider.id === 0 && this.state.windowType === 2;

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        {/*isAdding &&
                            <EditProviderForm onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                        */}

                        { /*!isAdding &&*/
                        <Table responsive className='table--bordered' dir="rtl">
                            <thead>
                            <tr>
                                <th></th>
                                <th>{TextManager.getCurrentTextResource().Providers.image}</th>
                                <th>{TextManager.getCurrentTextResource().Customers.name}</th>
                                <th>{TextManager.getCurrentTextResource().Customers.id}</th>

                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.providers.status,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(CellularRouteTable))